import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AssignPhoneNumberLabelModal from './assign-phone-number-label-modal';
import { getPhoneNumberLabelsRequest, setPhoneNumberLabelRequest, bulkSetPhoneNumberLabelRequest } from '../../../../../../extra-actions';
import { IProps } from './types';
import { RootState } from '../../../../../../../../store/root-reducer';


const AssignPhoneNumberLabelModalContainer: React.FC<IProps> = (props) => {
  const { selectedPhoneNumbers, deSelectedPhoneNumbers, isSelectAllAcrossPages, phoneNumberFilters, searchText, convertFiltersToAPIFormat } = props;
  const dispatch = useDispatch();
  const labelsList: string[] = useSelector((state: RootState) => state?.dialer?.phoneNumberLabels || []);
  const setPhoneNumberLabelRequestStatus = useSelector(
    (state: RootState) => state?.dialer?.setPhoneNumberLabelRequest,
  );
  const bulkSetPhoneNumberLabelRequestStatus = useSelector(
    (state: RootState) => state?.dialer?.bulkSetPhoneNumberLabelRequest,
  );

  const getLabelsListRequest = useCallback(
    (search?: string) => {
      dispatch(getPhoneNumberLabelsRequest({ search }));
    },
    [dispatch],
  );

  const handleSubmit = useCallback((labelName: string) => {
    const selectedCount = selectedPhoneNumbers?.length || 0;
    const deSelectedCount = deSelectedPhoneNumbers?.length || 0;

    if (selectedCount > 0 && deSelectedCount === 0 && selectedPhoneNumbers) {
      const phoneNumberIds = selectedPhoneNumbers.map((item) => item.id);
      dispatch(setPhoneNumberLabelRequest({
        phoneNumberIds,
        label: labelName,
      }));
    } else if (selectedCount === 0 && deSelectedCount >= 0 && deSelectedPhoneNumbers && isSelectAllAcrossPages) {
      const deselectedPhoneNumberIds = deSelectedPhoneNumbers.map((item) => item.id);
      const apiFilters = convertFiltersToAPIFormat?.(phoneNumberFilters, searchText);
      dispatch(bulkSetPhoneNumberLabelRequest({
        ...(deselectedPhoneNumberIds.length > 0 && { deselectedPhoneNumberIds }),
        phoneNumberFilters: apiFilters,
        label: labelName,
      }));
    }
  }, [selectedPhoneNumbers, deSelectedPhoneNumbers, isSelectAllAcrossPages, phoneNumberFilters, searchText, convertFiltersToAPIFormat, dispatch]);

  return (
    <AssignPhoneNumberLabelModal
      {...props}
      getLabelsListRequest={getLabelsListRequest}
      labelsList={labelsList}
      setPhoneNumberLabelRequestStatus={setPhoneNumberLabelRequestStatus}
      bulkSetPhoneNumberLabelRequestStatus={bulkSetPhoneNumberLabelRequestStatus?.status}
      onSubmit={handleSubmit}
    />
  );
};

export default memo(AssignPhoneNumberLabelModalContainer);

